import React, { useMemo } from 'react';
import formatPrice from 'utils/formatPrice';
import Table from 'modules/common/Table';
import TPLink from 'components/TP-UI/TPLink';
import { Routes } from 'constants/routeConstants';
import { getUrlWithParams } from 'helpers/router';
import { INITIAL_NET_DEPOSITS_FILTERS_VALUES } from '../../constants';
import useDashboardFilterFields from '../../hooks/useDashboardFilterFields';

const NetDepositView = ({ items, loading, form, sorting, onChange }) => {
  const fields = useDashboardFilterFields({ form });
  const filters = useMemo(
    () => ({
      fields: fields,
      form,
      initialValues: INITIAL_NET_DEPOSITS_FILTERS_VALUES,
      maxPrimaryFilters: 4,
    }),
    [form, fields],
  );

  const columns = useMemo(
    () => [
      {
        label: 'Name',
        dataKey: 'name',
        width: '180px',
        renderItem: (item) => {
          return (
            <TPLink path={getUrlWithParams(Routes.USER_MANAGEMENT_DETAILS_ID, { id: item._id })}>
              {item.name || item.email}
            </TPLink>
          );
        },
      },
      {
        label: 'Email',
        dataKey: 'email',
        width: '155px',
      },
      {
        label: 'Country',
        dataKey: 'country',
        width: '130px',
      },
      {
        label: 'Deposit',
        dataKey: 'deposit',
        sortable: true,
        format: formatPrice,
        width: '170px',
      },
      {
        label: 'Withdraw',
        dataKey: 'withdraw',
        format: formatPrice,
        sortable: true,
        width: '120px',
      },
      {
        label: 'Net Deposit',
        dataKey: 'netDeposit',
        format: formatPrice,
        sortable: true,
        width: '120px',
      },
    ],
    [],
  );

  return (
    <Table
      itemKey="_id"
      columns={columns}
      filters={filters}
      items={items}
      loading={loading}
      {...sorting}
      onChange={onChange}
      hidePagination
    />
  );
};

export default NetDepositView;
